import React, { createContext, useContext, useMemo, useState, useEffect } from "react";
import useUserRole from "../hooks/useUserRole"; // you already have this

const ViewModeContext = createContext(null);

export function ViewModeProvider({ children }) {
  const role = useUserRole(); // e.g., "Admin" | "Supervisor" | "Field User"
  const defaultMode = role === "Admin" ? "admin" : "supervisor";

  const [mode, setMode] = useState(() => {
    const saved = localStorage.getItem("schedule:viewMode");
    return saved || defaultMode;
  });

  // If your role changes (login as a different person), nudge the default
  useEffect(() => {
    if (!["admin", "supervisor"].includes(mode)) setMode(defaultMode);
  }, [role]); // eslint-disable-line

  useEffect(() => {
    localStorage.setItem("schedule:viewMode", mode);
  }, [mode]);

  const value = useMemo(() => ({ mode, setMode, role }), [mode, role]);
  return <ViewModeContext.Provider value={value}>{children}</ViewModeContext.Provider>;
}

export function useViewMode() {
  const ctx = useContext(ViewModeContext);
  if (!ctx) throw new Error("useViewMode must be used within ViewModeProvider");
  return ctx; // { mode, setMode, role }
}
